import React, { useState, useEffect } from "react";
import CheckboxGroup from "components/Input/CheckboxGroup";

import settings from "configs/settings";

import "assets/css/ConfirmGDPR.min.css";

/**
 * @usage
 * <ConfirmGDPR className={s.confirmGDPR} showValidationState={showValidationState} onChange={(e) => handleInputChange("gdpr", e.value, e.validation.decision)}/>
 */

const ConfirmGDPR = ({
  showValidationState,
  onChange = undefined,
  className,
}) => {
  const [checked, setChecked] = useState({
    value: false,
    validation: { decision: false },
  });

  useEffect(() => {
    if (onChange && typeof onChange === "function") {
      onChange(checked);
    }
  }, [checked]);

  const handleChange = (e) => {
    if (e?.value.length > 0)
      setChecked({ value: true, validation: { decision: true } });
    else setChecked({ value: false, validation: { decision: false } });
  };

  return (
    <CheckboxGroup
      showValidationState={showValidationState}
      validationState={checked.validation.decision}
      onChange={(e) => handleChange(e)}
      className={`confirmGDPR${
        showValidationState ? ` showValidationState` : ""
      }${!checked.validation.decision ? ` error` : ""}${
        className ? ` ${className}` : ""
      }`}
      options={[
        {
          label: (
            <span className="text">
              Elfogadom az&nbsp;
              {/* <a
                href={settings.files.termsOfUse}
                target="_blank"
                rel="noreferrer"
              >
                felhasználási feltételeket
              </a>
              &nbsp;és az&nbsp; */}
              <a
                href={settings.files.privacyPolicy}
                target="_blank"
                rel="noreferrer"
              >
                adatvédelmi irányelveket.
              </a>
            </span>
          ),
          value: 1,
        },
      ]}
    />
  );
};

export default ConfirmGDPR;
